import { render, staticRenderFns } from "./JeecgDemoTabsModal.vue?vue&type=template&id=ced019c6&scoped=true"
import script from "./JeecgDemoTabsModal.vue?vue&type=script&lang=js"
export * from "./JeecgDemoTabsModal.vue?vue&type=script&lang=js"
import style0 from "./JeecgDemoTabsModal.vue?vue&type=style&index=0&id=ced019c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced019c6",
  null
  
)

export default component.exports